import { useFieldArray } from "react-hook-form";
import { useDispatch } from "react-redux";
import MainSelect from "../../main-select/main-select";
import TextInput from "../../text-input/text-input";
import UploadFile from "../../uploads/file/file";
import MainButton from "../../button/button";
import { Delete, Add } from "@mui/icons-material";
import { FILE_TYPE_OPTIONS } from "../../../constant/partner";
import { deleteFile } from "../../../store/file/slice";

import styles from "../../../pages/partner/styles.module.scss";

const FileInputRow = ({ control, name, url }) => {
  const dispatch = useDispatch();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const removeFile = (index) => {
    dispatch(deleteFile(index));
    remove(index);
  };

  const appendFile = () => {
    append({
      name: "",
      file_select_type: "",
      issue_number: "",
      deadline: "",
      file: "",
    });
  };

  return (
    <div>
      <div className={styles.add_file_info}>
        <div className={styles.add_file_info_header}>
          <h3>📄 Փաստաթուղթ 1</h3>
        </div>
        <div className={styles.input_row}>
          <TextInput
            control={control}
            name={`${name}.0.name`}
            placeholder="Փաստաթղթի անուն"
            size="small"
          />
          <MainSelect
            control={control}
            name={`${name}.0.file_select_type`}
            options={FILE_TYPE_OPTIONS}
            className={styles.add_file_select}
            placeholder="Տեսակ"
          />
          <div className={styles.btn_block}>
            <MainButton
              type="button"
              onClick={appendFile}
              className={styles.add_btn}
              startIcon={<Add className={styles.btn_icon} />}
            />
          </div>
        </div>

        <div className={styles.date_row}>
          <div className={styles.radioBtnBlock}>
            <div>
              <h5>Տրման թիվ</h5>
              <TextInput
                control={control}
                name={`${name}.0.issue_number`}
                type="date"
                size="small"
              />
            </div>
          </div>
          <div className={styles.deadline}>
            <h5>Վերջնաժամկետ</h5>
            <TextInput
              control={control}
              name={`${name}.0.deadline`}
              type="date"
              size="small"
            />
          </div>
        </div>

        <div className={styles.container}>
          <UploadFile
            control={control}
            name={`${name}.0.file`}
            url={url}
            index={0}
            className={styles.add_file}
          />
        </div>
      </div>

      {fields.slice(1).map((field, index) => (
        <div key={field.id} className={styles.add_file_info}>
          <div className={styles.add_file_info_header}>
            <h3>📄 Փաստաթուղթ {index + 2}</h3>
          </div>
          <div className={styles.input_row}>
            <TextInput
              size="small"
              control={control}
              className={styles.input}
              name={`${name}.${index + 1}.name`}
              placeholder="Փաստաթղթի անուն"
            />
            <MainSelect
              control={control}
              name={`${name}.${index + 1}.file_select_type`}
              options={FILE_TYPE_OPTIONS}
              className={styles.add_file_select}
              placeholder="Տեսակ"
            />
            <div className={styles.btn_block}>
              <MainButton
                type="button"
                onClick={appendFile}
                className={styles.add_btn}
                startIcon={<Add className={styles.btn_icon} />}
              />

              <MainButton onClick={() => removeFile(index + 1)} type="button">
                <Delete className={styles.delete_icon} />
              </MainButton>
            </div>
          </div>

          <div className={styles.date_row}>
            <div className={styles.add_new_files}>
              <h4>Տրման թիվ</h4>
              <TextInput
                control={control}
                name={`${name}.${index + 1}.issue_number`}
                type="date"
                size="small"
              />
            </div>
            <div className={styles.increasing_deadline}>
              <h4>Վերջնաժամկետ</h4>
              <TextInput
                control={control}
                name={`${name}.${index + 1}.deadline`}
                type="date"
                size="small"
              />
            </div>
          </div>

          <div className={styles.container}>
            <UploadFile
              control={control}
              name={`${name}.${index + 1}.file`}
              url={url}
              index={index + 1}
              size="small"
              className={styles.add_file}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default FileInputRow;
